import authService from '@/services/authService';

/**
 * API请求拦截器
 * 自动为需要认证的请求添加token
 */
class ApiInterceptor {
  /**
   * 发送带认证的请求
   * @param {string} url 请求URL
   * @param {Object} options 请求选项
   * @returns {Promise<Response>}
   */
  async fetch(url, options = {}) {
    const token = authService.getToken();
    
    // 合并headers
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers
    };

    // 如果有token，添加到请求头
    if (token) {
      headers['katoken'] = token;
    }

    const requestOptions = {
      ...options,
      headers
    };

    try {
      const response = await fetch(url, requestOptions);
      
      // 如果返回401，说明token无效，清除token并跳转登录
      if (response.status === 401) {
        authService.clearToken();
        authService.redirectToLogin();
        throw new Error('未授权访问');
      }
      
      return response;
    } catch (error) {
      console.error('API请求失败:', error);
      throw error;
    }
  }

  /**
   * 发送POST请求
   * @param {string} url 请求URL
   * @param {Object|FormData|null} data 请求数据
   * @param {Object} options 请求选项
   * @returns {Promise<Response>}
   */
  async post(url, data, options = {}) {
    let body;
    let headers = { ...options.headers };

    // 如果data为null或undefined，不设置body
    if (data === null || data === undefined) {
      body = undefined;
    }
    // 如果是FormData，直接使用，不设置Content-Type
    else if (data instanceof FormData) {
      body = data;
      // 删除Content-Type，让浏览器自动设置multipart/form-data
      delete headers['Content-Type'];
    } else {
      // 如果是普通对象，转换为JSON
      body = JSON.stringify(data);
      headers['Content-Type'] = 'application/json';
    }

    return this.fetch(url, {
      method: 'POST',
      body,
      headers,
      ...options
    });
  }

  /**
   * 发送GET请求
   * @param {string} url 请求URL
   * @param {Object} options 请求选项
   * @returns {Promise<Response>}
   */
  async get(url, options = {}) {
    return this.fetch(url, {
      method: 'GET',
      ...options
    });
  }
}

export default new ApiInterceptor(); 